// Collections live in content/ and are edited in DataTrek.
// Re-exported here so existing imports keep working.
import categoriesData from "../content/categories.json";
import difficultiesData from "../content/difficulties.json";
import durationsData from "../content/durations.json";
import toursData from "../content/tours.json";
export const categories = categoriesData;
export const difficulties = difficultiesData;
export const durations = durationsData;
export const tours = toursData;
